import React from 'react';
import styled, { useTheme } from 'styled-components';
import { Translation } from '~/components/Translation';
import Check from '~/components/MaterialIcons/Check';
import ResponsiveText from '~/components/ResponsiveText';
import { media } from '~/styles/mixins';

const streamYardFeatureList = [
	<Translation
		key="landingWhyStreamYard.block.streamYardFeatures.onScreen"
		tid="landingWhyStreamYard.block.streamYardFeatures.onScreen"
	/>,
	<Translation
		key="landingWhyStreamYard.block.streamYardFeatures.logos"
		tid="landingWhyStreamYard.block.streamYardFeatures.logos"
	/>,
	<Translation
		key="landingWhyStreamYard.block.streamYardFeatures.multistream"
		tid="landingWhyStreamYard.block.streamYardFeatures.multistream"
	/>,
	<Translation
		key="landingWhyStreamYard.block.streamYardFeatures.preRecorded"
		tid="landingWhyStreamYard.block.streamYardFeatures.preRecorded"
	/>,
	<Translation
		key="landingWhyStreamYard.block.streamYardFeatures.onScreenComments"
		tid="landingWhyStreamYard.block.streamYardFeatures.onScreenComments"
	/>,
	<Translation
		key="landingWhyStreamYard.block.streamYardFeatures.fullHD"
		tid="landingWhyStreamYard.block.streamYardFeatures.fullHD"
	/>,
	<Translation
		key="landingWhyStreamYard.block.streamYardFeatures.greenScreen"
		tid="landingWhyStreamYard.block.streamYardFeatures.greenScreen"
	/>,
	<Translation
		key="landingWhyStreamYard.block.streamYardFeatures.downloadRecordings"
		tid="landingWhyStreamYard.block.streamYardFeatures.downloadRecordings"
	/>,
	<Translation
		key="landingWhyStreamYard.block.streamYardFeatures.customRTMP"
		tid="landingWhyStreamYard.block.streamYardFeatures.customRTMP"
	/>,
	<Translation
		key="landingWhyStreamYard.block.streamYardFeatures.screenSharing"
		tid="landingWhyStreamYard.block.streamYardFeatures.screenSharing"
	/>,
	<Translation
		key="landingWhyStreamYard.block.streamYardFeatures.support"
		tid="landingWhyStreamYard.block.streamYardFeatures.support"
	/>,
	<Translation
		key="landingWhyStreamYard.block.streamYardFeatures.separateAudio"
		tid="landingWhyStreamYard.block.streamYardFeatures.separateAudio"
	/>,
	<Translation
		key="landingWhyStreamYard.block.streamYardFeatures.customBanners"
		tid="landingWhyStreamYard.block.streamYardFeatures.customBanners"
	/>,
	<Translation
		key="landingWhyStreamYard.block.streamYardFeatures.layoutTemplates"
		tid="landingWhyStreamYard.block.streamYardFeatures.layoutTemplates"
	/>,
	// TODO - Uncomment once we have teams on the consumer plans
	// <Translation
	// 	key="landingWhyStreamYard.block.streamYardFeatures.rolesAndPermissions"
	// 	tid="landingWhyStreamYard.block.streamYardFeatures.rolesAndPermissions"
	// />,
];

const StreamYardFeatureWrap = styled.div`
	border-radius: 16px;
	padding: 20px;
	background: ${props => props.theme.colors.background.white};
	box-shadow: -8px 9px 48px rgba(218, 224, 236, 0.22);
	width: 100%;
	max-width: 670px;
	${media.xLarge`
		padding: 32px;
	`}
`;

const StyledHeaderWrap = styled.div`
	border-radius: 8px;
	background: ${props => props.theme.colors.background.slate};
	padding: 16px;
	${media.xLarge`
	`}
`;

const FeatureListHeaderText = styled(ResponsiveText)`
	margin: 0;
	${media.large`
		text-align: left;
	`}
`;

const FeatureListWrap = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	${media.medium`
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  `}
`;

const FeatureListItemWrap = styled.div`
	flex-basis: 50%;
	display: flex;
	max-width: 256px;
	padding: 12px 0;
	border-bottom: 2px solid ${props => props.theme.colors.background.slate};
`;

const StyledListItemText = styled(ResponsiveText)`
	line-height: 1;
	margin: 0 0 0 8px;
`;

const CheckWrap = styled.div`
	width: 16px;
`;

const StreamYardFeatureList = () => {
	const theme = useTheme();

	return (
		<StreamYardFeatureWrap>
			<StyledHeaderWrap>
				<FeatureListHeaderText textAlign="center" component="h2" variant="h5">
					<Translation tid="landingWhyStreamYard.block.streamYardFeatures.header" />
				</FeatureListHeaderText>
			</StyledHeaderWrap>
			<FeatureListWrap>
				{streamYardFeatureList.map((listItem, index) => (
					<FeatureListItemWrap key={index}>
						<CheckWrap>
							<Check fill={theme.colors.primary.main} size="16" />
						</CheckWrap>
						<StyledListItemText variant="body">{listItem}</StyledListItemText>
					</FeatureListItemWrap>
				))}
			</FeatureListWrap>
		</StreamYardFeatureWrap>
	);
};

export default StreamYardFeatureList;
